import React, { Component } from "react";
import { message, Upload, Image, Space, Button } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { getToken } from "../../core/auth";
import { getUrl } from "../../service/oss";
import { getServerOSS } from "../../core/options";
import { Modal } from "@/nano";

import "./index.less";

const DEFAULT_ACCEPT = ".jpeg,.png";

export default class PictureUpload extends Component {

  state = {
    width: "100%",
    height: "100%",
    loading: false,
  };

  headers = {
    "Authorization": getToken(),
  };

  constructor(props) {
    super(props);
    const { width, height } = this.props;
    if (width) {
      this.state.width = width;
    }
    if (height) {
      this.state.height = height;
    }
  }

  getAccept = () => {
    return this.props.accept || DEFAULT_ACCEPT;
  };

  getUploadURL = () => {
    return getServerOSS().uploadURL;
  };

  onRefDiv = (ele) => {
    const { width, height, } = this.state;
    if (ele && "100%" === width && "100%" === height) {
      this.setState({
        ...this.state,
        width: ele.clientWidth,
        height: ele.clientHeight,
      });
    }
  };

  getImgStyle = () => {
    let { width, height, } = this.state;
    if (width) {
      if (typeof width === "number") {
        width = width - 2;
      } else if (width.includes("px")) {
        width = Number(width.replace("px")) - 2 + "px";
      }
    }
    if (height) {
      if (typeof height === "number") {
        height = height - 2;
      } else if (height.includes("px")) {
        height = Number(height.replace("px")) - 2 + "px";
      }
    }
    return {
      width,
      height,
    };
  };

  onChange = (info) => {
    const { file } = info
    if ("uploading" === file.status) {
      this.setState({
        ...this.state,
        loading: true,
      });
      return;
    }

    if ("done" === file.status) {
      this.setState({
        ...this.state,
        loading: false,
      });
      const { code, data } = file.response;
      if (200 === code) {
        const { path } = data;
        this.props.onChange && this.props.onChange(path, data);
      }
      return;
    }
  };

  onBeforeUpload = (file) => {
    const accept = this.getAccept();
    const splits = file.name.split(".");
    if (accept && -1 === accept.indexOf(splits[splits.length - 1])) {
      message.error("请检查文件类型!");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("上传文件超过2M!");
      return false;
    }

    return true;
  };

  onImageBoxClick = (e) => {
    e.stopPropagation();
  };

  preview = () => {
    const { isShowMaskText=true, disabled } = this.props
    return {
      mask: (
        <Space>
          <Button className="preview-btn" type="text" size="small" icon={<EyeOutlined />}>{isShowMaskText&&'预览'}</Button>
          {!disabled && <Button className="preview-btn" danger type="text" size="small" icon={<DeleteOutlined />} onClick={this.onDelete}>{isShowMaskText&&'删除'}</Button>}
        </Space>
      ),
    };
  };

  onDelete = (e) => {
    e.stopPropagation();

    Modal.confirm({
      title: "是否确认删除？",
      okText: "确认",
      cancelText: "取消",
      onOk: () => {
        this.props.onChange && this.props.onChange();
      },
      onCancel: () => {
        return false;
      }
    })
  };

  render() {
    const { value, disabled,isShowUploadText=true } = this.props;
    const { width, height, loading, openFileDialogOnClick, } = this.state;
    return (
      <div
        className="picture-upload"
        ref={this.onRefDiv}
        style={{
          width,
          height,
          maxWidth: width,
          maxHeight: height,
        }}
      >
        <Upload
          name="file"
          listType="picture-card"
          disabled={disabled}
          showUploadList={false}
          headers={this.headers}
          onChange={this.onChange}
          accept={this.getAccept()}
          action={this.getUploadURL()}
          beforeUpload={this.onBeforeUpload}
          openFileDialogOnClick={openFileDialogOnClick}
        >
          {value ? (
            <div
              style={{
                width: "100%",
                height: "100%",
              }}
              onClick={this.onImageBoxClick}
            >
              <Image
                alt=""
                src={getUrl(value)}
                preview={this.preview()}
                style={this.getImgStyle()}
              />
            </div>
          ) : (
            <div>
              {loading ? <LoadingOutlined /> : <PlusOutlined />}
              <div
                style={{
                  display: isShowUploadText?"block":"none",
                  marginTop: 8,
                }}
              >
                点击上传
              </div>
            </div>
          )}
        </Upload>
      </div>
    );
  };

}
